



























import Vue from "vue";
import Home from "@/components/Home.vue";

declare const __COMMIT_HASH__: string;

export default Vue.extend({
  name: "App",
  components: {
    Home
  },
  methods: {
    commitHash: function (): string {
      return __COMMIT_HASH__;
    },
  }
});
